import {VolumePipe} from './pipe/volume.pipe';
import {DialogConfiguracaoExibicaoCamposService} from './configuracao-exibicao-campos';
import {ConfiguracaoExibicaoCampos} from './configuracao-exibicao-campos/configuracao-exibicao-campos.component';
import {MetrosToKmPipe} from './pipe/metros-to-km.pipe';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule, MatChipsModule,
    MatDialogModule,
    MatIconModule,
    MatListModule,
    MatPaginatorModule,
    MatProgressBarModule, MatRadioModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule
} from '@angular/material';
import {MaxNgLibModule} from 'max-ng-lib';
import {ListPaginatorComponent} from './list-paginator/list-paginator.component';
import {PageListagemComponent} from './page-listagem/page-listagem.component';
import {DataPipe, DateTimePipe} from './pipe/date.pipe';
import {CommonModule} from '@angular/common';
import {DialogPopupPesquisaComponent} from './dialog-popup-pesquisa';
import {JoinPipe} from './pipe/join.pipe';
import {GetObjectPipe} from './pipe/get-object.pipe';
import {CapacidadeFormaterPipe} from './pipe/capacidade.pipe';
import {BotaoMenuSelecaoConfigComponent, DialogMenuSelecaoConfigComponent} from './menu-selecao-configuracao';
import {KiloFormaterPipe} from './pipe/kilo.pipe';
import {MetroCubicoPipe} from './pipe/metro-cubico.pipe';
import {
  BotaoConfiguracaoExibicaoCamposComponent
} from './configuracao-exibicao-campos/botao-configuracao-exibicao-campos/botao-configuracao-exibicao-campos.component';
import {
  DialogAlertaZonaRiscoRoteirizacaoComponent
} from 'src/app/content/pages/components/roteirizacao/components/dialogs/dialog-alerta-zona-risco-roteirizacao/dialog-alerta-zona-risco-roteirizacao.component';
import { ConvertDiaSemanaPipe } from './pipe/convert-dia-semana.pipe';
import {CpfPipe} from './pipe/cpf.pipe';
import {ListaPaginadaModule} from './lista-paginada/lista-paginada.module';
import {ListaPaginadaComponent} from './lista-paginada/lista-paginada.component';
import { DescricaoTipoVendaPipe } from './pipe/descricao-tipo-venda.pipe';
import { FiltroPedidosComponent } from './filtro-pedidos/filtro-pedidos.component';
import { RestricaoTransportePipe } from './pipe/restricao-transporte.pipe';
import {
  DialogAlertaTempoMaximoViagemDistAutomaticoComponent
} from '../../content/pages/components/roteirizacao/components/dialogs/dialog-alerta-tempo-maximo-viagem-dist-automatico/dialog-alerta-tempo-maximo-viagem-dist-automatico.component';
import {TokenAutorizacaoValidacaoModule} from './token-autorizacao-validacao/token-autorizacao-validacao.module';
import {FiltroClientesComponent} from './filtro-clientes/filtro-clientes.component';
import {DialogPopupRodizioVeiculoComponent} from './dialog-popup-info-rodizio-veiculo/dialog-popup-rodizio-veiculo.component';
import { FiltroTransbordoComponent } from './filtro-transbordo/filtro-transbordo.component';
import { DialogBaseConhecimentoComponent } from './base-conhecimento-dialog/dialog-base-conhecimento/dialog-base-conhecimento.component';

@NgModule({
    imports: [
        DragDropModule,
        CommonModule,
        MaxNgLibModule,
        MatIconModule,
        MatTableModule,
        MatButtonModule,
        MatSortModule,
        MatTooltipModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatCardModule,
        MatDialogModule,
        MatSelectModule,
        MatListModule,
        MatCheckboxModule,
        ListaPaginadaModule,
        MatChipsModule,
        TokenAutorizacaoValidacaoModule,
        MatRadioModule
    ],
  declarations: [
    ConfiguracaoExibicaoCampos,
    ListPaginatorComponent,
    PageListagemComponent,
    DialogPopupPesquisaComponent,
    BotaoMenuSelecaoConfigComponent,
    DialogMenuSelecaoConfigComponent,
    DialogAlertaZonaRiscoRoteirizacaoComponent,
    DialogAlertaTempoMaximoViagemDistAutomaticoComponent,

    // pipes
    CapacidadeFormaterPipe,
    GetObjectPipe,
    JoinPipe,
    KiloFormaterPipe,
    DateTimePipe,
    DataPipe,
    MetrosToKmPipe,
    MetroCubicoPipe,
    VolumePipe,
    BotaoConfiguracaoExibicaoCamposComponent,
    ConvertDiaSemanaPipe,
    CpfPipe,
    DescricaoTipoVendaPipe,
    FiltroPedidosComponent,
    RestricaoTransportePipe,
    FiltroClientesComponent,
    FiltroTransbordoComponent,
    DialogBaseConhecimentoComponent
  ],
    exports: [
        BotaoConfiguracaoExibicaoCamposComponent,
        ConfiguracaoExibicaoCampos,
        ListPaginatorComponent,
        ListaPaginadaComponent,
        PageListagemComponent,
        DialogPopupPesquisaComponent,
        DataPipe,
        DateTimePipe,
        JoinPipe,
        GetObjectPipe,
        CapacidadeFormaterPipe,
        MetrosToKmPipe,
        MetroCubicoPipe,
        VolumePipe,
        KiloFormaterPipe,
        ConvertDiaSemanaPipe,
        DescricaoTipoVendaPipe,
        CpfPipe,
        RestricaoTransportePipe
    ],

  providers: [DialogConfiguracaoExibicaoCamposService],
  entryComponents: [
    ConfiguracaoExibicaoCampos,
    DialogAlertaZonaRiscoRoteirizacaoComponent,
    DialogAlertaTempoMaximoViagemDistAutomaticoComponent,
    DialogBaseConhecimentoComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedComponentsModule {
}
